"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get a position value which centers 2 elements vertically or horizontally
 */
var centerBySize = function (originSize, targetSize) {
    return Math.floor(originSize / 2 - targetSize / 2);
};
exports.default = centerBySize;
